export const environment = {
  production: true,
  appUrl: 'https://demo.univacity.com',
  mainServiceEndpoint: 'https://api.dev.univacity.com/main/v1',
  mediaServiceEndpoint: 'https://api.dev.univacity.com/file/v1',
  notificationServiceEndpoint: 'https://api.dev.univacity.com/email/v1',

  externalLinks: {
    blog: 'https://blog.univacity.com',
    helpDesk: 'https://helpdesk.univacity.com',
    careers: 'https://careers.univacity.com',
  },
  companyName: 'Univacity',

  segementWriteKey: 'DxXOXAnzwXad4wSN9XEpxAoU01lZqegT',

  flutterwavePublicKey: 'FLWPUBK_TEST-89c84b8d0882cdc148462439c214c129-X',

  monnify: {
    apiKey: 'MK_TEST_U1R3ECKHHY',
    contractCode: '7496230612',
  },

  posthog: {
    key: 'phc_TkJN0YQbvCaML9J2rsY9nMXXMz7zWiCvSrpKjcK8hN8',
    host: 'https://eu.i.posthog.com',
  },

  recaptchaKey: '6LejSAUrAAAAADVifGT1aNBeymKqduD-jV1jzyu8',

  seo: {
    defaultDescription:
      'Univactiy - Apply for Admission into 1000+ Institute All Over World. ',
    defaultKeywords: [
      'Univacity',
      $localize`Study Abroad`,
      $localize`Admission`,
      $localize`Online Application`,
      $localize`University`,
      $localize`Universities search`,
      $localize`International Student`,
      $localize`Universities`,
      $localize`Programs`,
      $localize`Program Search`,
      $localize`Tours`,
      $localize`Education Tours`,
      $localize`Tuition Payment`,
      $localize`Student visa`,
      $localize`Visa`,
      $localize`Hostel`,
      $localize`Hostel Search`,
      $localize`Scholarship`,
      $localize`Scholarship Search`,
      $localize`Fligth`,
      $localize`Student Flight`,
      $localize`Cheap flights`,
      $localize`Affordable flights`,
      $localize`Affordable schools`,
      $localize`Best universities`,
    ],
    separator: '-',
    postfix: 'Univacity',
    twitterHandle: 'univacity_',
    facebookAppId: '546685526860610',
    facebookHandle: 'univacityofficial',
    linkedinHandle: 'univacity',
  },

  screen: {
    sm: 576,
    md: 821,
    lg: 992,
    xlg: 1200,
  },
};
